import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Spacer.scss';

const Spacer = ({ content, setup }) => {
	const height = parseInt(content.height, 10) || 100;
	return <div className={s.spacer} style={{ height: `${setup.breakPoint === 'mobile' ? height / 2 : height}px` }} />;
};

export default hot(module)(Spacer);
